export const colors = [
  '#ba96d9',
  '#925ac4',
  '#3f205a',
  '#9DAEE8',
  '#6B69E7',
  '#1535A7',
  '#AEE0D4',
  '#5FBFAE',
  '#298A79',
  '#AEEFA3',
  '#68DC55',
  '#38A526',
  '#DCDF8C',
  '#CFD444',
  '#909422',
  '#EE9D9D',
  '#CB4E4E',
  '#BC2525',
  '#D799B6',
  '#E35698',
  '#981C55',
];

export const colorsHouseholdByIncome = [
  '#096412',
  '#0B991A',
  '#5AE769',
  '#ADFDB5',
  '#F5F93D',
  '#FFDC5F',
  '#FFA629',
  '#FF6929',
  '#EE0909',
];

export const colorsConsumptionByIncome = colorsHouseholdByIncome;

export const colorsPieCharts = [
  '#ba96d9',
  '#925ac4',
  '#793ead',
  '#3f205a',
  '#a2a4a4',
];

export const zoningColors = {
  ZC: '#8E7A71',
  ZCA: '#A58673',
  'ZC-ZEIS': '#BC947D',
  'ZCOR-1': '#5D63A4',
  'ZCOR-2': '#4C9FD6',
  'ZCOR-3': '#99BCDD',
  ZCORa: '#72A6A9',
  ZM: '#BCBCBC',
  ZMa: '#CACACA',
  ZMIS: '#A0A0A0',
  ZMISa: '#DFDFDF',
  'ZEIS-1': '#D9CDA2',
  'ZEIS-2': '#FFBE73',
  'ZEIS-3': '#FFDD88',
  'ZEIS-4': '#FFE9AC',
  'ZEIS-5': '#FFF7D0',
  'ZDE-1': '#986892',
  'ZDE-2': '#BE90A0',
  'ZPI-1': '#7D7399',
  'ZPI-2': '#C3ADD0',
  'AC-1': '#C5F973',
  'AC-2': '#D9EFA3',
  ZEU: '#A35D61',
  ZEUa: '#D86978',
  ZEUP: '#AE7878',
  ZEUPa: '#AE9D9D',
  ZEM: '#D7A9A0',
  ZEMP: '#D8A789',
  ZPR: '#FFFF6E',
  'ZER-1': '#FFE9AC',
  'ZER-2': '#FFD578',
  ZERa: '#BFBF1E',
  ZPDS: '#92A98B',
  ZPDSr: '#B4BC8F',
  ZEPAM: '#84C3A0',
  ZEP: '#67896E',
  Zoe: '#D3CBAE',
};

export const AVERAGE_INCOME = [
  {
    id: '1',
    checked: false,
    color: '#096412',
    label: 'Maior que R$ 48.808,01 por domicílio',
  },
  {
    id: '2',
    checked: false,
    color: '#0B991A',
    label: 'Entre R$ 28.669,01 e 48.808,00 por domicílio',
  },
  {
    id: '3',
    checked: false,
    color: '#5AE769',
    label: 'Entre R$ 16.471,01 e R$ 28.669,00 por domicílio',
  },
  {
    id: '4',
    checked: false,
    color: '#89EFBE',
    label: 'Entre R$ 7.838,01 e R$ 16.471,00 por domicílio',
  },
  {
    id: '5',
    checked: false,
    color: '#F5F93D',
    label: 'Entre R$ 4.145,01 e R$ 7.838,00 por domicílio',
  },
  {
    id: '6',
    checked: false,
    color: '#FFDC5F',
    label: 'Entre R$ 2.323,01 e R$ 4.145,00 por domicílio',
  },
  {
    id: '7',
    checked: false,
    color: '#FFA629',
    label: 'Entre R$ 1.202,01 e R$ 2.323,00 por domicílio',
  },
  {
    id: '8',
    checked: false,
    color: '#FF6929',
    label: 'Entre R$ 999,01 e R$ 1.202,00 por domicílio',
  },
  {
    id: '9',
    checked: false,
    color: '#EE0909',
    label: 'Abaixo de R$ 999,00 por domicílio',
  },
];

export const heatmapLegend = [
  '#FF0B00',
  '#FCD41B',
  '#F8FB22',
  '#BEF835',
  '#8DB8BF',
];
